export default __webpack_public_path__ + "static/media/001-python.07a98139.png";